import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, Icon } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsUnavailableProduct = () => {
  return (
    <View style={styles.container}>
      <Icon
        name="IconInfo"
        color={theme.colors.CHARCOAL}
        width={16}
        height={16}
        style={styles.icon}
      />

      <BodyText sizeMatch={['14']} style={styles.text}>
        <FormattedMessage {...messages.unavailableProduct} />
      </BodyText>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  unavailableProduct: {
    defaultMessage:
      'This product isn’t available at this location right now — select another location to order.',
    description: 'Product details | Unavailable product message',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: theme.spacing['2'],
  },
  icon: {
    flexShrink: 0,
  },
  text: {
    color: theme.colors.CHARCOAL,
  },
});
